function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}.primary-fill{fill:#4f4954;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("polygon", {
  className: "cls-1",
  points: "257.32 256.66 0 256 0 0 257.32 0.66 257.32 256.66"
})), React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M38.47,121.49l15.84-10.56S73,94,91.93,87.17s56.1-15.51,98.68,4.29c17.53,8.16,41.58,22.77,41.58,22.77s-14.69,30.94-17.66,35.23-11.6,15.81-44.72,21.86-54.23,2.09-78.43-2.42-30.8-12.43-38.06-16.06-27.94-7.7-27.94-7.7l-2.75-14.08Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("circle", {
  className: "highlights",
  cx: 128.88,
  cy: 129.25,
  r: 37.98
}), React.createElement("rect", {
  className: "highlights",
  x: 25.87,
  y: 129.22,
  width: 16.94,
  height: 13.64
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M37.64,121.74l15.84-10.56s18.7-16.94,37.63-23.76,56.1-15.52,98.67,4.29c17.54,8.15,41.58,22.77,41.58,22.77s-13.53,33-16.5,37.29S202.1,165.52,169,171.57s-54.76,4.34-78.43-2.42c-7.7-2.2-30.81-12.43-38.07-16.06s-27.94-7.7-27.94-7.7L21.8,131.31Z"
}), React.createElement("circle", {
  className: "primary",
  cx: 129.38,
  cy: 129,
  r: 45.54
}), React.createElement("path", {
  className: "primary-fill",
  d: "M157.4,128a28.33,28.33,0,1,1-20.34-27.2,16.07,16.07,0,1,0,17.8,16c0-.18,0-.36,0-.54A28.15,28.15,0,0,1,157.4,128Z"
}), React.createElement("path", {
  className: "primary",
  d: "M48.53,118.27A52.8,52.8,0,0,0,46.8,132,51.74,51.74,0,0,0,48.86,147"
}), React.createElement("path", {
  className: "primary",
  d: "M211.6,151.3a77.11,77.11,0,0,0,3.19-22.52A75.75,75.75,0,0,0,211,104.4"
})));
var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 257.32 256.66",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eye.267f7f2c.svg";
export { ForwardRef as ReactComponent };